// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"42a7c055","86":"ac442df2","272":"51d47876","283":"3b6d5537","453":"821fd3de","509":"0ec00735","773":"bdd394ab","780":"ee95fa06","831":"8b088a75","836":"155f4508","842":"67000489","953":"260a95d1"}[chunkId] + ".chunk.js";
};